import { configureStore, Action, getDefaultMiddleware  } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import { ThunkAction } from 'redux-thunk';
import { createStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

// const store = createStore(rootReducer);


const persistConfig = {
  key: 'root',
  version: 1,
  blacklist:['userDashboard'],
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer , window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

// For Future
// const store = configureStore({
//   reducer: rootReducer
// })

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  })
})

const persistor = persistStore(store)

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default
    store.replaceReducer(newRootReducer)
  })
}

export {store, persistor}
// export default store;
